import React from "react";


const Map_detail = () => {
    return (
        <div>
            <div className="map_section">
                <div className="inner_area">
                    <div className="map_area">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d22551.3331847032!2d11.
                        498978684257043!3d45.046913283329324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477f00b
                        f7ae8bb97%3A0xeac9c73f3429a485!2s45020%20Canda%2C%20Province%20of%20Rovigo%2C%20Italy!5e0!3m2!1sen!2sin
                        !4v1653631772792!5m2!1sen!2sin" width="100%" height="500"
                            style={{ marginRight: 10 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        <div className="btn_area">
                            <button className="btn-primary-2 w-100" >Get Direction</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Map_detail;